const EventBus = window.VueEventBus
import CartMixins from '../../_mixins/location-checkout'
export default {
  name: 'races-cart-item',
  settings: 'page.cart',
  translations: 'page.cart',
  mixins: [CartMixins],
  props: {
    item: {},
    items: {},
    groupedItems: {},
    cartView: {},
    showItemRates: {
      default: false
    },
  },
  data() {
    return {
    }
  },
  created() {
    this.mayRemoveThisCartItem()
  },
  computed: {

  },
  methods: {
    mayRemoveThisCartItem() {
      const item = this.item
      const id = item.id
      const items = _.cloneDeep(this.currentCartItems)

      // all race (point package) type needs to have a parent reservation product and the child is
      //registered as an item  in reservation product's attributes.childItems array
      const hasParent = _.some(items, (cartItem) => {
        //point package type
        const isReservation = cartItem.type === 'race-reservations'
        if (isReservation) {
          const childItems = _.get(cartItem, 'attributes.childItems', [])
          if (childItems.includes(id)) {
            return true
          }
        }
        return false
      })

      // This product does have a parent - i.e.,  may be abandoned due to prolong inactivity
      // but still remains in the cart storage because it has not been deleted. This can happen
      // due to choice of different packages and the parent reservation product still remains same but
      // this product is no longer registers as a child of the parent - hence abandoned
      // But, the cart adds it for payment - hence remove it
      if (!hasParent) {
        this.removeCartItem({id})
        EventBus.$emit('cart-item-deleted', item, this, this.$parent)
        EventBus.$emit('cart-item-deleted-' + item.type, item, this, this. $parent)
      }

    },
  }
}
